// Corporate Actions: the routes and the sidebar rows of `wealth.ops.corporate-actions` (ADR-0027).
import { lazy } from 'react';
import { defineWebFeature } from '@/features/kit';

const CoacMailboxUpdatesCard = lazy(() =>
    import('@/components/coac/CoacUpdateCards').then((m) => ({
        default: m.CoacMailboxUpdatesCard,
    })),
);

export default defineWebFeature({
    id: 'wealth.ops.corporate-actions',
    slots: {
        // SEP-376. The dashboard alert of the bell of the COAC Mailbox tab:
        // the corporate actions with an update that the signed-in Operations
        // user has not read. The card reads its rows inside its component, so
        // `count` is null, as for the transfer updates card (SEP-296).
        'ops.dashboard.cards': [
            {
                key: 'coac-mailbox-updates',
                order: 30,
                span: 6,
                title: 'COAC Mailbox updates',
                summary: 'The corporate actions with an update that you have not read.',
                rows: 5,
                count: () => null,
                emptyBehaviour: 'keep',
                Component: CoacMailboxUpdatesCard,
            },
        ],
    },
    routes: [
        {
            frontend: 'ops',
            path: 'corporate-actions',
            lazy: () => import('@/pages/ops/corporate-actions/page'),
        },
        {
            // SEP-379. The full page of the pane of the Overview, Register and
            // Calendar tabs.
            frontend: 'ops',
            path: 'corporate-actions/:id',
            lazy: () => import('@/pages/ops/corporate-actions/detail/page'),
        },
        {
            // SEP-379. The full page of the pane of the COAC Mailbox tab.
            frontend: 'ops',
            path: 'corporate-actions/mailbox/:id',
            lazy: () => import('@/pages/ops/corporate-actions/mailbox/page'),
        },
        {
            // SEP-379. The full page of the EDI pane of the Calendar and EDI
            // tabs. The page shows an empty state when the EDI feed is off.
            frontend: 'ops',
            path: 'corporate-actions/edi/:id',
            lazy: () => import('@/pages/ops/corporate-actions/edi/page'),
        },
    ],
    nav: [
        {
            frontend: 'ops',
            key: 'corporate-actions',
            label: 'Corporate Actions',
            href: '/ops/corporate-actions',
            icon: 'Building2',
            group: 'processing',
            order: 230,
        },
    ],
});
